import { render, staticRenderFns } from "./RailwayTicketManage.vue?vue&type=template&id=350f5f7f&scoped=true&"
import script from "./RailwayTicketManage.vue?vue&type=script&lang=js&"
export * from "./RailwayTicketManage.vue?vue&type=script&lang=js&"
import style0 from "./RailwayTicketManage.vue?vue&type=style&index=0&id=350f5f7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f5f7f",
  null
  
)

export default component.exports